type type = "technical" | "language";

export const open = (type: type) => {
  window.dispatchEvent(new CustomEvent("vue:chat-open", { detail: { type } }));
};
